import { Box, Button, Loader, Tooltip } from '@wix/design-system';
import { SparklesSmall } from '@wix/wix-ui-icons-common';
import React from 'react';
export const GenerateWithAiButton = _ref => {
  let {
    missingCount,
    label,
    isGenerating = false,
    isDisabled = false,
    disabledTooltip,
    onClick,
    onTooltipShow
  } = _ref;
  const buttonDisabled = isDisabled || isGenerating;
  const showTooltip = !!disabledTooltip && isDisabled;

  // TODO: consider replacing hardcoded px values below with SP tokens
  const button = /*#__PURE__*/React.createElement(Box, {
    paddingTop: "3px"
  }, /*#__PURE__*/React.createElement(Button, {
    dataHook: "generate-ai-button-button",
    disabled: buttonDisabled,
    gap: "SP1",
    prefixIcon: /*#__PURE__*/React.createElement(Box, {
      margin: "0 4px 0 -6px"
    }, isGenerating ? /*#__PURE__*/React.createElement(Box, {
      paddingRight: "2px"
    }, /*#__PURE__*/React.createElement(Loader, {
      size: "tiny"
    })) : /*#__PURE__*/React.createElement(SparklesSmall, null)),
    priority: "secondary",
    size: "tiny",
    weight: "thin",
    ellipsis: true,
    onClick: onClick
  }, `${label} (${missingCount})`));
  if (showTooltip) {
    return /*#__PURE__*/React.createElement(Box, {
      dataHook: "generate-ai-button-container"
    }, /*#__PURE__*/React.createElement(Tooltip, {
      content: /*#__PURE__*/React.createElement(Box, {
        align: "left",
        direction: "vertical",
        gap: "SP2",
        padding: "0 0 SP1 0"
      }, disabledTooltip),
      size: "small",
      inline: true,
      onShow: onTooltipShow
    }, button));
  }
  return /*#__PURE__*/React.createElement(Box, {
    dataHook: "generate-ai-button-container"
  }, button);
};
//# sourceMappingURL=generate-with-ai-button.js.map